import widgetProps from './props.js';

const View = () => import('./component/view.vue');
const Form = () => import('./component/form.vue');

export default {
  View,         // 大屏显示的视图
  Form,         // 表单
  widgetProps,  // 表单数据属性配置
};
